import { OrganizationRoles } from 'src/enums'

/**
 * Who can manage the Bill Pay "Bank Account" surface (nav item + page): org
 * owners/admins, plus FULL-visibility bookkeepers (EX-40473). Selective
 * bookkeepers are excluded — full visibility is inferred from the
 * ORGANIZATION_USER_STATISTICS user-feature (only granted to full-visibility
 * bookkeepers) combined with the bookkeeper org role. This mirrors the backend
 * `managepayments` SpiceDB permission.
 *
 * This is the single source of truth so the nav and the page can never disagree
 * (a divergence here is what regressed access in EX-40413). Both surfaces MUST
 * derive their gate from this helper.
 */
export const canManageBillPay = (args: {
  hasOrgAdminPermissions: boolean | undefined
  organizationRole: OrganizationRoles | undefined
  orgUserStatisticsEnabled: boolean | undefined
}): boolean =>
  args.hasOrgAdminPermissions === true ||
  (args.organizationRole === OrganizationRoles.bookkeeper &&
    !!args.orgUserStatisticsEnabled)
